import { Text } from "waapi/waap-ui/components/Text/Text.js";
import { flex } from "waapi/waap-ui/components/Flex/Flex.style.js";
import styled from "styled-components";

export const InlineText = styled(Text)`
    display: inline-block;
`;

export const ImportDoneWrapper = styled.div`
    ${flex};
    padding: ${({ theme: { spacing } }) => `${spacing[12]} 0 ${spacing[4]}`};
    max-width: 100%;
    min-width: 0;
`;
